"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class ComponentContainer {
    constructor(packageLoader, componentLoader) {
        this.components = {};
        packageLoader.keys()
            .forEach(key => {
            const packageData = packageLoader(key);
            if (packageData.main) {
                const path = this.resolvePath(packageData);
                const key = this.resolveKey(path);
                this.register(key, componentLoader(path));
            }
        });
    }
    get(name) {
        const component = this.components[name];
        if (component === void (0)) {
            return null;
        }
        return component;
    }
    register(name, component) {
        if (this.components[name] !== undefined) {
            return;
        }
        this.components[name] = component.default || component;
    }
    resolvePath(packageData) {
        const location = packageData.name.replace('@dialogexe', '.');
        return `${location}/${packageData.main}`;
    }
    resolveKey(path) {
        return path.split('/')[1];
    }
}
exports.ComponentContainer = ComponentContainer;
exports.default = new ComponentContainer(require.context('components', true, /cw-component[a-zA-Z\/\-]+package\.json$/), require.context('components', true, /cw-component[a-zA-Z\/\-]+\.tsx?$/));



// WEBPACK FOOTER //
// ./src/core/container/ComponentContainer.ts